export default __webpack_public_path__ + "static/media/count-pin.728e3cf2.svg";